import React, { Component } from "react";
import * as Sentry from "@sentry/react";
import TLDRChunkLoadError from "../../TldrApp/TLDRChunkLoadError";
import CookieDisabled from "./CookieDisabled";

const hasStorage = () => {
  try {
    localStorage.setItem("test-storage", "test-storage");
    localStorage.removeItem("test-storage");
    return true;
  } catch (err) {
    return false;
  }
};

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    // You can also log the error to an error reporting service
    console.error("Error Boundary Caught:", error, errorInfo);

    if (error.name === "ChunkLoadError") {
      Sentry.captureMessage(error.toString());
    } else {
      Sentry.captureException(error);
    }
  }

  render() {
    const { error, hasError } = this.state;

    if (hasError) {
      if (error.name === "ChunkLoadError") {
        return <TLDRChunkLoadError />;
      } else if (!hasStorage()) {
        return <CookieDisabled />
      }
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
